import React, { useState, useEffect, useRef } from 'react';
import { preloadAllCardImages } from './Card';

const cardSuits = ['H', 'D', 'C', 'S'];
const cardValues = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
const cardBacks = ['1B', '2B'];

const CardImageLoader: React.FC = () => {
    const [loadedImages, setLoadedImages] = useState(0);
    const [totalImages, setTotalImages] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const isMounted = useRef(true);
    const loadingStartTime = useRef(Date.now());

    useEffect(() => {
        // Set up cleanup function
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        // Calculate total images (52 cards + 2 backs + 4 suits)
        const total = (cardSuits.length * cardValues.length) + cardBacks.length;
        setTotalImages(total);

        // Use the preloadAllCardImages function with a progress callback
        const loadImages = async () => {
            try {
                // Start preloading
                await preloadAllCardImages();
                
                // If component is still mounted, update state
                if (isMounted.current) {
                    setLoadedImages(total);
                    setIsLoading(false);
                }
            } catch (error) {
                console.error('Error preloading card images:', error);
                
                // Even on error, hide the loader after a timeout
                if (isMounted.current) {
                    setIsLoading(false);
                }
            }
        };

        loadImages();

        // Set a maximum time to show the loader (5 seconds)
        const timeoutId = setTimeout(() => {
            if (isMounted.current) {
                setIsLoading(false);
            }
        }, 5000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    // Calculate loading progress percentage
    const progressPercentage = Math.min(100, Math.round((loadedImages / totalImages) * 100));
    
    // Calculate time elapsed
    const timeElapsed = Date.now() - loadingStartTime.current;
    
    // Hide loader if it's been visible for more than 5 seconds or loading is complete
    if (!isLoading || timeElapsed > 5000) {
        return null;
    }

    return (
        <div>
        </div>
        // <div style={{ 
        //     position: 'fixed', 
        //     bottom: 10, 
        //     right: 10, 
        //     fontSize: '12px', 
        //     backgroundColor: 'rgba(0,0,0,0.7)', 
        //     padding: '8px 12px', 
        //     borderRadius: '5px', 
        //     fontFamily: 'Inter, serif',
        //     zIndex: 9999,
        //     display: 'flex',
        //     flexDirection: 'column',
        //     gap: '4px'
        // }}>
        //     <div>Loading cards: {loadedImages}/{totalImages}</div>
        //     <div style={{
        //         width: '100%',
        //         height: '4px',
        //         backgroundColor: 'rgba(255,255,255,0.2)',
        //         borderRadius: '2px',
        //         overflow: 'hidden'
        //     }}>
        //         <div style={{
        //             width: `${progressPercentage}%`,
        //             height: '100%',
        //             backgroundColor: '#3de361',
        //             transition: 'width 0.3s ease-in-out'
        //         }} />
        //     </div>
        // </div>
    );
};

export default React.memo(CardImageLoader);
